import React from "react";
import "./Styles/Footer.css";

const Footer = () => {
  return (
    <>
      <footer>
        Designed and developed by Mina Sameh
        <span>🧡</span>
      </footer>
    </>
  );
};

export default Footer;
